import {PortalDomainOrg, PortalNotification, PortalNotificationReference, PortalNotificationType} from '../types'

const nonCancellableTasks: Partial<PortalNotificationType>[] = ['CashToCloseTask', 'SigningTask', 'IdCheckTask', 'FincenFormTask']
const nonCancellableStates: Extract<keyof PortalNotification, keyof PortalNotificationReference>[] = ['IsFormComplete', 'IsComplete', 'IsPlaidOffered']

//Any is needed because IsPlaidOffered does not exist on PortalNotificationReference, but exists on PortalNotification
export function showUserCancelFunction(notification: PortalNotification | PortalNotificationReference, org: PortalDomainOrg) {
  return !org.DisablePortalUserTaskCancellation && !nonCancellableTasks.includes(notification.Type) && !nonCancellableStates.some(key => Boolean(notification[key]))
}
